import React, {Component} from "react";
import { Redirect } from "react-router-dom";
import Cookies from 'js-cookie'
import auth from  '../../services/AuthService'
import Loader from "../loader/Loader.component";

let hash = Cookies.get('PHPSESSID')
console.log(hash)
if(process.env.REACT_APP_ENV === 'development') {
  hash = 'j8j2fuko1b6suemvb19u57oti2'
  // k0ti0g7tv28tql20jdjdnbuvh0
}
class VerificationComponent extends Component {
  state = {
    loading: true
  }
  async componentDidMount() {
    if (!auth.isLoggedIn()) {

      const token = await auth.verify({hash})
      if(!token) {
        window.location = `https://drive.skygenic.com/#!/login`
        //window.location = `https://drive.skygenic.com/#!/login?returnUrl=${window.location.href}`
      }
      if(auth.isLoggedIn()) {
        this.setState({loading: false})
        return <Redirect to='/' />
      }
    } else {
      return <Redirect to='/' />
    }
  }
  render() {
    return (
      <div>
        {
          this.state.loading ? <div className="loader flex-center"><Loader /></div>: <Redirect to={'/'} />
        }
      </div>
    )
  }
}

export default VerificationComponent;

// eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwNTQwNzRmOGM0MWNjNGNiYTQzMzNlZiIsIm5hbWUiOiJCb2JieSBLIiwiaWF0IjoxNjI2MjE5MjQ0fQ.xlMMsBL5ec9h-zkDBaw4a6boFLQQMJp0G0b8DaUJE7c

// {
//   "sub": "1234567890",
//   "name": "John Doe",
//   "iat": 1516239022
// }